import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Mail, Download, Trash2 } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { EmptyState, UploadButton } from './RecordHelpers';

export const CommunicationsTab = ({ communications, term, onDeleteComm, onUploadOpen }) => (
  <div className="space-y-4">
    <div className="flex justify-end"><UploadButton tab="communications" defaultType="letter" onOpen={onUploadOpen} /></div>
    {communications.filter(c => (c.title || '').toLowerCase().includes(term)).length === 0 ? (
      <EmptyState icon={Mail} message={term ? 'No matches' : 'No communications yet'} sub="Upload letters, memoranda, and other correspondence" />
    ) : (
      <div className="space-y-2">
        {communications.filter(c => (c.title || '').toLowerCase().includes(term)).map(c => (
          <Card key={c.id} className="border-[#E2E6EA]" data-testid={`comm-${c.id}`}>
            <CardContent className="p-3 flex items-center gap-3">
              <div className="p-1.5 bg-[#00A3A3]/10 rounded">
                <Mail className="h-4 w-4 text-[#00A3A3]" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-[#1A1D21] truncate">{c.title}</h4>
                <div className="flex items-center gap-2 mt-0.5">
                  <Badge variant="outline" className="text-[10px] capitalize">{c.comm_type}</Badge>
                  {c.file_name && <span className="text-[10px] text-[#A8B1B9]">{c.file_name}</span>}
                  {c.created_at && <span className="text-[10px] text-[#A8B1B9]">{format(parseISO(c.created_at), 'MMM d, yyyy')}</span>}
                </div>
                {c.description && <p className="text-xs text-[#5A6570] mt-1 line-clamp-1">{c.description}</p>}
              </div>
              <div className="flex gap-1 shrink-0">
                {c.file_url && <a href={c.file_url} target="_blank" rel="noreferrer"><Button variant="ghost" size="sm" className="h-7 w-7 p-0"><Download className="h-3.5 w-3.5 text-[#5A6570]" /></Button></a>}
                <Button variant="ghost" size="sm" className="h-7 w-7 p-0 text-red-500 hover:text-red-700" onClick={() => onDeleteComm(c.id)} data-testid={`delete-comm-${c.id}`}><Trash2 className="h-3.5 w-3.5" /></Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    )}
  </div>
);
